import * as React from "react";
import CustomerService from "../../../services/CustomerService";
import DelendPaginator from "../../../components/Paginator/DelendPaginator";
import { Box, Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import EmptyListState from "../../../components/Vectors/EmptyListState";
import DelendDrawer from "../../../components/AppBar/DelendDrawer";
import { DelendTabPanel } from "../../../components/Tabs";
import CreateNaturalPersonConsent from "./CreateNaturalPersonConsent";
import CreateLegalPersonConsent from "./CreateLegalPersonConsent";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import { isLegalPerson } from "../../../services/UtilsService";

const EmptyState = ({ handleDrawerOpen }) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <EmptyListState />

        <Typography
          sx={{ ml: 2, fontWeight: 600, mb: "24px" }}
          color="inherit"
          noWrap
        >
          Você ainda não possui uma lista de consentimentos
        </Typography>

        <Typography
          sx={{ ml: 2, fontWeight: 400, color: "#8087A6" }}
          color="inherit"
          noWrap
        >
          Olá! Bem-vindo a plataforma Delend. Use o botão abaixo para solicitar
        </Typography>

        <Typography
          sx={{ ml: 2, fontWeight: 400, color: "#8087A6", mb: "24px" }}
          color="inherit"
          noWrap
        >
          o Open Finace e assim aumentar a sua carteira de clientes.
        </Typography>
        <Button onClick={handleDrawerOpen} variant="outlined">
          solicitar Open Finance
        </Button>
      </Box>
    </React.Fragment>
  );
};

const RightSideBar = ({ open, handleDrawerClose, value, handleChange, preFill }) => {
  return (
    <DelendDrawer
      open={open}
      handleCloser={handleDrawerClose}
      title="Solicitar Open Finance"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab sx={{ textTransform: "none" }} label="Pessoa Física" />
              <Tab sx={{ textTransform: "none" }} label="Pessoa Jurídica" />
            </Tabs>
          </Box>
          <DelendTabPanel value={value} index={0}>
            <CreateNaturalPersonConsent preFill={preFill} handleDrawerClose={handleDrawerClose} />
          </DelendTabPanel>
          <DelendTabPanel value={value} index={1}>
            <CreateLegalPersonConsent preFill={preFill} handleDrawerClose={handleDrawerClose} />
          </DelendTabPanel>
        </Grid>
      </Grid>
    </DelendDrawer>
  );
};

const ListConsent = () => {
  const [rows, setRow] = React.useState([]);
  const [isFetched, setIsFetched] = React.useState(false);
  const [preFill, setPreFill] = React.useState({});
  const fetchCustomerList = async () => {
    const response = await CustomerService.listCustomer();
    setIsFetched(true);
    if (response) {
      setRow(response.customers);
    }
  };

  React.useEffect(() => {
    fetchCustomerList();
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = (prop) => {
    setPreFill(prop);
    const currentIndex = (prop && prop.documentNumber && isLegalPerson(prop.documentNumber)) ? 1 : 0;
    setValue(currentIndex);
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  if (!isFetched) {
    return <DelendCentralizedCircularProgress />;
  }

  if (isFetched && rows.length === 0) {
    return (
      <React.Fragment>
        <EmptyState handleDrawerOpen={handleDrawerOpen} />

        <RightSideBar
          open={open}
          handleDrawerClose={handleDrawerClose}
          value={value}
          handleChange={handleChange}
          preFill={preFill}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <DelendPaginator open={open} key={rows} rows={rows} onClick={handleDrawerOpen} />

      <RightSideBar
        open={open}
        handleDrawerClose={handleDrawerClose}
        value={value}
        handleChange={handleChange}
        preFill={preFill}
      />
    </React.Fragment>
  );
};

export default ListConsent;
